import React from 'react';
import Image from 'next/image';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';
import { arrowRight } from 'icons/default';
import Symbol from 'assets/logotype/symbol.svg';

import { inputBorderStyling } from './inputBorderStyling';
import styles from './Control.module.scss';

interface SelectOptions {
  label: string;
  value: number;
}

interface Props {
  title: string;
  buttonText: string;
  withBackground?: boolean;
}

export const Control: React.FC<Props> = ({ title, buttonText, withBackground = true }) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch('licensePlate');
  const options: SelectOptions[] = [];

  for (let i = 1; i < 60; i += 1) {
    const min = i * 500;
    const max = min + 499;

    options.push({ label: `${min} - ${max}`, value: max });
  }

  return (
    <div className={styles.wrapper}>
      {withBackground && <Symbol className={styles.symbol} />}
      <label htmlFor="licensePlate">{title}</label>
      <div className={styles['number-plate']}>
        <Image src="/assets/images/number-plate.svg" alt="Number plate" width={30} height={60} />
        <input
          {...register('licensePlate')}
          id="licensePlate"
          type="text"
          style={inputBorderStyling[value?.length ?? 0]}
          maxLength={6}
          autoComplete="off"
        />
      </div>
      <ErrorMessage
        name="licensePlate"
        errors={errors}
        render={({ message }) => <span className={styles.errorMessage}>{message}</span>}
      />
      <select {...register('mileage')} id="mileage" defaultValue="">
        <option disabled value="">
          Miltal (frivilligt)
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <Button
        type={ButtonType.Submit}
        size={ButtonSize.Medium}
        variant={ButtonVariant.Primary}
        trailingIcon={arrowRight}
        stretch={false}
      >
        {buttonText}
      </Button>
    </div>
  );
};
